/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {WarningModalService} from "../../../../services/warning-modal/warning-modal.service";
import {AbstractModalComponent} from "../../../abstract-modal/abstract-modal.component";
import {ConstantsService} from "../../../../services/constants/constants.service"
import moment from 'moment';

@Component({
  selector: 'app-xref-add-recipient-modal',
  templateUrl: './xref-add-recipient-modal.component.pug',
  styleUrls: ['./xref-add-recipient-modal.component.scss'],
  standalone: false
})
export class XrefAddRecipientModalComponent extends AbstractModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('requestForm', {static: false}) requestForm: any;
  total = 0;
  errorMessage = {};
  errorTotalExits = $localize`The number of total recipients for exit surveys cannot exceed 5000.`
  END_DATE_MONTHS: string[] = [];
  listOfYears: number[] = [];
  recipient = {
    firstName: '',
    lastName: '',
    email: '',
    country_code: '',
    mobile_phone: '',
    selectedMonth: -1,
    selectedYear: -1
  }
  disableSend = true;
  saved = false;
  emailOutOfFocus: boolean = false;
  mobileNumberTouched: boolean = false;
  employmentDropdowntouched: boolean = false;
  employmentDropdownOnFocus: boolean = true;

  constructor(public _bsModalRef: BsModalRef,
    public modal: WarningModalService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.checkTotalRecipients();
    this.END_DATE_MONTHS = moment.months();
    let currentYear = Number(moment().format('yyyy'))
    for (let i = currentYear+1; i >= 1970; i--) {
      this.listOfYears.push(i)
    }
  }

  changeValue() {
    // making sure that either email or phone is entered before allowing data
    if (this.recipient.firstName.trim() && this.recipient.lastName.trim() && this.recipient.selectedMonth !== -1 && this.recipient.selectedYear !== -1 && (this.recipient.email || this.recipient.mobile_phone)) {
      this.disableSend = false;
      this.checkTotalRecipients();
    } else this.disableSend = true;
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  addRecipient() {
    this.saved = true;
    if (this.recipient.mobile_phone === 'null') this.recipient.mobile_phone = ''
    if (!this.recipient.mobile_phone) this.recipient.country_code = '';
    let payload = {
      "first_name": this.recipient.firstName,
      "last_name": this.recipient.lastName,
      "email": this.recipient.email,
      "country_code": this.recipient.country_code,
      "mobile_phone": this.recipient.mobile_phone,
      "end_date_month": this.recipient.selectedMonth,
      "end_date_year": this.recipient.selectedYear,
    }
    if (this.recipient.firstName && this.recipient.lastName && this.recipient.selectedMonth !== -1 && this.recipient.selectedYear !== -1 || (this.recipient.email && this.recipient.mobile_phone)) {
      this.disableSend = false;
      this.checkTotalRecipients();
      this.nextClick.emit({data: payload});
      this._bsModalRef.hide();
    }
  }

  getForm() {
    return this.requestForm;
  }

  phoneUpdate(event) {
    this.recipient.country_code = event['country_code'];
    this.recipient.mobile_phone = this.recipient.mobile_phone = event['mobile_phone'] === 'null' ? '' : event['mobile_phone'];
    this.formDirty = true;
    this.changeValue();
  }

  checkTotalRecipients() {
    if (this.total >= ConstantsService.EXITS_RECIPIENTS_LIMIT) {
      this.disableSend = true;
      this.errorMessage = {
        'type': 'danger',
        'message': this.errorTotalExits
      };
    }
  }
}
